import React from "react";
import { Link } from "react-router-dom";

/**
 * Pill button with a rotating conic-gradient border + soft halo glow.
 * Use as a button or an internal link.
 */
const GlowButton = ({
  children,
  to,
  onClick,
  type = "button",
  size = "md",
  className = "",
}) => {
  const sizes = {
    sm: "px-6 py-2.5 text-sm",
    md: "px-8 py-3.5 text-base",
    lg: "px-10 py-4 text-lg",
  };

  const inner = (
    <span
      className={`fluid-bg relative block rounded-full bg-black text-white font-bold tracking-wide ${sizes[size]} ${className}`}
    >
      <span className="relative z-10">{children}</span>
    </span>
  );

  const wrapper = "glow-border inline-block rounded-full";

  if (to) {
    return (
      <Link to={to} className={wrapper}>
        {inner}
      </Link>
    );
  }
  return (
    <button type={type} onClick={onClick} className={wrapper}>
      {inner}
    </button>
  );
};

export default GlowButton;
